<template>
  <div>
    <el-tabs
      v-show="!isEmergencyResource"
      class="custom-tabs"
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane label="重要企业" name="first">重要企业</el-tab-pane>
      <el-tab-pane label="停车场" name="second">停车场</el-tab-pane>
    </el-tabs>
    <el-tabs
      v-show="isEmergencyResource"
      class="custom-tabs"
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane label="物资仓库" name="first">
        <ComponentMaterialStorage :center="center" :searchText="searchText" />
      </el-tab-pane>
      <el-tab-pane label="救援队伍" name="second">
        <ComponentRescueTeam :center="center" :searchText="searchText" />
      </el-tab-pane>
      <el-tab-pane label="运输资源" name="third">
        <ComponentTranresourcesmanage :center="center" :searchText="searchText" />
      </el-tab-pane>
      <el-tab-pane label="避难场所" name="fourth">
        <ComponentSheltermanage :center="center" :searchText="searchText" />
      </el-tab-pane>
      <el-tab-pane label="通讯资源" name="fifth">
        <ComponentCommunicationresources :center="center" :searchText="searchText" />
      </el-tab-pane>
      <el-tab-pane label="医疗资源" name="sixth">
        <ComponentMedicalResources :center="center" :searchText="searchText" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ComponentMaterialStorage from "./Components/Component-MaterialStorage";
import ComponentRescueTeam from "./Components/Component-RescueTeam";
import ComponentTranresourcesmanage from "./Components/Component-Tranresourcesmanage";
import ComponentSheltermanage from "./Components/Component-Sheltermanage";
import ComponentCommunicationresources from "./Components/Component-Communicationresources";
import ComponentMedicalResources from "./Components/Component-MedicalResources";

export default {
  name: "componentPOISearchResult",
  componentName: "componentPOISearchResult",
  props: {
    isEmergencyOperations: {
      type: Boolean,
      default: false
    },
    center: {
      type: Object,
      default: function() {
        return [0, 0];
      }
    },
    searchText: {
      type: String,
      default: ""
    }
  },
  components: {
    ComponentMaterialStorage: ComponentMaterialStorage,
    ComponentRescueTeam: ComponentRescueTeam,
    ComponentTranresourcesmanage: ComponentTranresourcesmanage,
    ComponentSheltermanage: ComponentSheltermanage,
    ComponentCommunicationresources: ComponentCommunicationresources,
    ComponentMedicalResources: ComponentMedicalResources
  },
  data() {
    return {
      activeName: "first",
      includedComponents: "componentPOISearchResult",
      isEmergencyResource: true
    };
  },
  created() {
    if (!this.isEmergencyOperations) {
      this.$on("onMapToogleSwitchClick", this.handleMapToogleSwitchClick);
    } else {
      this.isEmergencyResource = true;
    }
  },
  methods: {
    handleMapToogleSwitchClick(type) {
      this.isEmergencyResource = !(type == "重要元素监控");
    }
  }
};
</script>